import React from 'react'
import { UncontrolledCollapse, Button } from 'reactstrap';
import Main_Logo from '../../images/Main_Logo.png'
import Metamask from '../../images/metamask.png'
import {ChevronDown, Bell, ExternalLink, Lock, Minus, Plus} from 'react-feather'

function CardComponent() {
    return (
        <div className="row">

            {/* Card One */}
            <div className="card card_view col-md-4 mb-3 p-3">
              <div className="card-header custom_header card_header_background">
                <div className="d-flex">
                  <div className="col-8">
                    <span className="card_header_black">Earn SFINU</span><br />
                    <span className="card_header_yellow">Stake SFINU</span><br />
                    <span className="card_header_black_sm">Reflection BNB</span>
                  </div>
                  <div className="col-4 m-1 text-end">
                    <img src={Main_Logo} />
                  </div>
                </div>
              </div>
              <div className="card-body custom_body">
                <div className="d-flex">
                  <div className="col-6">
                    <span className="card_header_black_md">APR:</span><br />
                    <span className="card_text_blue">LOCK DURATION</span><br />
                    <span className="card_text_blue">DEPOSIT FEE</span><br />
                    <span className="card_text_blue">WITHDRAW FEE</span><br />
                  </div>
                  <div className="col-6 text-end">
                    <span className="card_header_black_md">42.56%</span><br />
                    <span className="card_header_black_md">UNLOCKED</span><br />
                    <span className="card_header_black_md">2.00 %</span><br />
                    <span className="card_header_black_md">0.00 %</span><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU EARNED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                  <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">BNB REFLECTED</span><br />
                    <span className="card_header_black_md">0.245632</span><br />
                    <span className="card_text_blue">~35.21 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                    <Button size="sm" type="primary" className="col-10 mt-1 custom_expand_area_button custom_expand_area_button_text">Harvest</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU STAKED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button className="custom_outline_button" outline color="info"><Minus /></Button>
                    <Button className="custom_outline_button" outline color="info"><Plus /></Button>
                  </div>
                </div>
              </div>

              <UncontrolledCollapse className="area_hidden_border" toggler="#toggler1">
                  <div className="d-flex m-3">
                    <div className="col-6">
                      <span className="card_header_black_md">TOTAL STAKED:</span><br />
                      <span className="card_header_black_md">ENDS IN:</span><br />
                    </div>

                    <div className="col-6 text-end">
                      <span className="card_header_black_md">122,564,475,458 SFINU</span><br />
                      <span className="card_text_yellow">9,324,364 blocks <Bell size={15} color="#fcb034" /></span><br />

                      <a className="card_text_blue">See Token Info <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Website <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Contract <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_header_black_md">Add to Metamask <img src={Metamask} style={{width : '20px'}} /></a><br />
                    </div>
                  </div>
              </UncontrolledCollapse>

              <div className="card-footer custom_card_footer pt-3 pb-3">
                <div className="d-flex">
                  <div className="col-6">
                    <Button size="sm" type="primary" className="custom_expand_area_button custom_expand_area_button_text"><Lock size={15} style={{marginTop: '-4px', marginRight: '7px'}} />Manual</Button>
                  </div>
                  <div className="col-6 text-end">
                    <a id="toggler1" className="card_header_black_bold">Details <ChevronDown size={18} style={{marginTop: '-2px'}}/></a>
                  </div>
                </div>
              </div>
            </div>
          

          {/* Card Two */}
          <div className="card card_view col-md-4 mb-3 p-3">
              <div className="card-header custom_header card_header_background">
                <div className="d-flex">
                  <div className="col-8">
                    <span className="card_header_black">Earn SFINU</span><br />
                    <span className="card_header_yellow">Stake SFINU</span><br />
                    <span className="card_header_black_sm">Reflection BNB</span>
                  </div>
                  <div className="col-4 m-1 text-end">
                    <img src={Main_Logo} />
                  </div>
                </div>
              </div>
              <div className="card-body custom_body">
                <div className="d-flex">
                  <div className="col-6">
                    <span className="card_header_black_md">APR:</span><br />
                    <span className="card_text_blue">LOCK DURATION</span><br />
                    <span className="card_text_blue">DEPOSIT FEE</span><br />
                    <span className="card_text_blue">WITHDRAW FEE</span><br />
                  </div>
                  <div className="col-6 text-end">
                    <span className="card_header_black_md">42.56%</span><br />
                    <span className="card_header_black_md">UNLOCKED</span><br />
                    <span className="card_header_black_md">2.00 %</span><br />
                    <span className="card_header_black_md">0.00 %</span><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU EARNED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                  <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">BNB REFLECTED</span><br />
                    <span className="card_header_black_md">0.245632</span><br />
                    <span className="card_text_blue">~35.21 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                    <Button size="sm" type="primary" className="col-10 mt-1 custom_expand_area_button custom_expand_area_button_text">Harvest</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU STAKED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button className="custom_outline_button" outline color="info"><Minus /></Button>
                    <Button className="custom_outline_button" outline color="info"><Plus /></Button>
                  </div>
                </div>
              </div>

              <UncontrolledCollapse className="area_hidden_border" toggler="#toggler2">
                  <div className="d-flex m-3">
                    <div className="col-6">
                      <span className="card_header_black_md">TOTAL STAKED:</span><br />
                      <span className="card_header_black_md">ENDS IN:</span><br />
                    </div>

                    <div className="col-6 text-end">
                      <span className="card_header_black_md">122,564,475,458 SFINU</span><br />
                      <span className="card_text_yellow">9,324,364 blocks <Bell size={15} color="#fcb034" /></span><br />

                      <a className="card_text_blue">See Token Info <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Website <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Contract <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_header_black_md">Add to Metamask <img src={Metamask} style={{width : '20px'}} /></a><br />
                    </div>
                  </div>
              </UncontrolledCollapse>

              <div className="card-footer custom_card_footer pt-3 pb-3">
                <div className="d-flex">
                  <div className="col-6">
                    <Button size="sm" type="primary" className="custom_expand_area_button custom_expand_area_button_text"><Lock size={15} style={{marginTop: '-4px', marginRight: '7px'}} />Manual</Button>
                  </div>
                  <div className="col-6 text-end">
                    <a id="toggler2" className="card_header_black_bold">Details <ChevronDown size={18} style={{marginTop: '-2px'}}/></a>
                  </div>
                </div>
              </div>
            </div>
            

          {/* Card Three */}
          <div className="card card_view col-md-4 mb-3 p-3">
              <div className="card-header custom_header card_header_background">
                <div className="d-flex">
                  <div className="col-8">
                    <span className="card_header_black">Earn SFINU</span><br />
                    <span className="card_header_yellow">Stake SFINU</span><br />
                    <span className="card_header_black_sm">Reflection BNB</span>
                  </div>
                  <div className="col-4 m-1 text-end">
                    <img src={Main_Logo} />
                  </div>
                </div>
              </div>
              <div className="card-body custom_body">
                <div className="d-flex">
                  <div className="col-6">
                    <span className="card_header_black_md">APR:</span><br />
                    <span className="card_text_blue">LOCK DURATION</span><br />
                    <span className="card_text_blue">DEPOSIT FEE</span><br />
                    <span className="card_text_blue">WITHDRAW FEE</span><br />
                  </div>
                  <div className="col-6 text-end">
                    <span className="card_header_black_md">42.56%</span><br />
                    <span className="card_header_black_md">UNLOCKED</span><br />
                    <span className="card_header_black_md">2.00 %</span><br />
                    <span className="card_header_black_md">0.00 %</span><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU EARNED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                  <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">BNB REFLECTED</span><br />
                    <span className="card_header_black_md">0.245632</span><br />
                    <span className="card_text_blue">~35.21 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                    <Button size="sm" type="primary" className="col-10 mt-1 custom_expand_area_button custom_expand_area_button_text">Harvest</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU STAKED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button className="custom_outline_button" outline color="info"><Minus /></Button>
                    <Button className="custom_outline_button" outline color="info"><Plus /></Button>
                  </div>
                </div>
              </div>

              <UncontrolledCollapse className="area_hidden_border" toggler="#toggler3">
                  <div className="d-flex m-3">
                    <div className="col-6">
                      <span className="card_header_black_md">TOTAL STAKED:</span><br />
                      <span className="card_header_black_md">ENDS IN:</span><br />
                    </div>

                    <div className="col-6 text-end">
                      <span className="card_header_black_md">122,564,475,458 SFINU</span><br />
                      <span className="card_text_yellow">9,324,364 blocks <Bell size={15} color="#fcb034" /></span><br />

                      <a className="card_text_blue">See Token Info <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Website <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Contract <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_header_black_md">Add to Metamask <img src={Metamask} style={{width : '20px'}} /></a><br />
                    </div>
                  </div>
              </UncontrolledCollapse>

              <div className="card-footer custom_card_footer pt-3 pb-3">
                <div className="d-flex">
                  <div className="col-6">
                    <Button size="sm" type="primary" className="custom_expand_area_button custom_expand_area_button_text"><Lock size={15} style={{marginTop: '-4px', marginRight: '7px'}} />Manual</Button>
                  </div>
                  <div className="col-6 text-end">
                    <a id="toggler3" className="card_header_black_bold">Details <ChevronDown size={18} style={{marginTop: '-2px'}}/></a>
                  </div>
                </div>
              </div>
            </div>
            

          {/* Card Four */}
          <div className="card card_view col-md-4 mb-3 p-3">
              <div className="card-header custom_header card_header_background">
                <div className="d-flex">
                  <div className="col-8">
                    <span className="card_header_black">Earn SFINU</span><br />
                    <span className="card_header_yellow">Stake SFINU</span><br />
                    <span className="card_header_black_sm">Reflection BNB</span>
                  </div>
                  <div className="col-4 m-1 text-end">
                    <img src={Main_Logo} />
                  </div>
                </div>
              </div>
              <div className="card-body custom_body">
                <div className="d-flex">
                  <div className="col-6">
                    <span className="card_header_black_md">APR:</span><br />
                    <span className="card_text_blue">LOCK DURATION</span><br />
                    <span className="card_text_blue">DEPOSIT FEE</span><br />
                    <span className="card_text_blue">WITHDRAW FEE</span><br />
                  </div>
                  <div className="col-6 text-end">
                    <span className="card_header_black_md">42.56%</span><br />
                    <span className="card_header_black_md">UNLOCKED</span><br />
                    <span className="card_header_black_md">2.00 %</span><br />
                    <span className="card_header_black_md">0.00 %</span><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU EARNED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                  <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">BNB REFLECTED</span><br />
                    <span className="card_header_black_md">0.245632</span><br />
                    <span className="card_text_blue">~35.21 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button size="sm" type="primary" className="col-10 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                    <Button size="sm" type="primary" className="col-10 mt-1 custom_expand_area_button custom_expand_area_button_text">Harvest</Button><br />
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <div className="col-6">
                    <span className="card_text_yellow">SFINU STAKED</span><br />
                    <span className="card_header_black_md">12,543,324.23435</span><br />
                    <span className="card_text_blue">~12.54 USD</span><br />
                  </div>

                  <div className="col-6 text-end">
                    <Button className="custom_outline_button" outline color="info"><Minus /></Button>
                    <Button className="custom_outline_button" outline color="info"><Plus /></Button>
                  </div>
                </div>
              </div>

              <UncontrolledCollapse className="area_hidden_border" toggler="#toggler4">
                  <div className="d-flex m-3">
                    <div className="col-6">
                      <span className="card_header_black_md">TOTAL STAKED:</span><br />
                      <span className="card_header_black_md">ENDS IN:</span><br />
                    </div>

                    <div className="col-6 text-end">
                      <span className="card_header_black_md">122,564,475,458 SFINU</span><br />
                      <span className="card_text_yellow">9,324,364 blocks <Bell size={15} color="#fcb034" /></span><br />

                      <a className="card_text_blue">See Token Info <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Website <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_text_blue">View Contract <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                      <a className="card_header_black_md">Add to Metamask <img src={Metamask} style={{width : '20px'}} /></a><br />
                    </div>
                  </div>
              </UncontrolledCollapse>

              <div className="card-footer custom_card_footer pt-3 pb-3">
                <div className="d-flex">
                  <div className="col-6">
                    <Button size="sm" type="primary" className="custom_expand_area_button custom_expand_area_button_text"><Lock size={15} style={{marginTop: '-4px', marginRight: '7px'}} />Manual</Button>
                  </div>
                  <div className="col-6 text-end">
                    <a id="toggler4" className="card_header_black_bold">Details <ChevronDown size={18} style={{marginTop: '-2px'}}/></a>
                  </div>
                </div>
              </div>
            </div>
            

            
        </div>
    )
}

export default CardComponent
